/**
 * Express Payment Methods Resource Client
 * Axios-based API client for express payment methods
 */
export class ExpressPaymentMethodsResource {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    /**
     * Get enabled payment methods for a checkout session
     */
    async getPaymentMethods(sessionId) {
        return this.apiClient.get(`/api/v1/payment-methods?checkoutSessionId=${encodeURIComponent(sessionId)}`);
    }
    /**
     * Update checkout session address (for express checkout flows)
     */
    async updateCheckoutSessionAddress(sessionId, data) {
        return this.apiClient.post(`/api/v1/checkout-sessions/${sessionId}/address`, data);
    }
    /**
     * Update customer email
     */
    async updateCustomerEmail(customerId, data) {
        return this.apiClient.post(`/api/v1/customers/${customerId}`, data);
    }
}
